import React, { useState } from "react";
import Headercomponent from "./Headercomponent";

const ChatWithPharmacist = () => {
  const [isButtonHovered, setIsButtonHovered] = useState(false);

  const openWhatsApp = () => {
    const url = `https://wa.me/${+2349139281851}`;
    window.open(url, "_blank");
  };

  return (
    <div style={styles.pageContainer}>
      <Headercomponent />
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.textContainer}>
            <div style={styles.iconContainer}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#00796b"
                width="48px"
                height="48px"
              >
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.116.553 4.092 1.513 5.818L0 24l6.414-1.482C8.071 23.45 10.007 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.852 0-3.626-.5-5.145-1.452l-.372-.222-3.795.877.831-3.72-.242-.381C2.493 15.92 2 14.011 2 12 2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zm5.094-6.762c-.278-.139-1.644-.813-1.9-.906-.257-.093-.444-.139-.632.139-.186.277-.73.906-.897 1.093-.168.186-.334.209-.613.07-.278-.14-1.171-.431-2.23-1.373-.823-.733-1.378-1.638-1.539-1.917-.162-.278-.017-.429.122-.57.126-.126.278-.327.417-.49.14-.163.186-.279.28-.465.093-.186.046-.347-.023-.49-.07-.14-.613-1.473-.84-2.015-.221-.533-.445-.461-.63-.47l-.54-.01c-.186 0-.488.07-.74.35s-.972.95-.972 2.318 1.03 2.69 1.174 2.879c.139.186 2.032 3.107 4.93 4.352.688.297 1.225.475 1.642.61.69.22 1.316.189 1.813.114.553-.082 1.644-.67 1.877-1.319.232-.65.232-1.207.162-1.33-.07-.122-.255-.186-.532-.325z" />
              </svg>
            </div>
            <h2 style={styles.heading}>Chat with Our Pharmacist</h2>
            <p style={styles.infoText}>
              Have questions about your health or medications? Our licensed pharmacists are available on WhatsApp to provide professional advice and answer your questions. Get personalized guidance in just a few clicks.
            </p>
          </div>
          <button
            style={{
              ...styles.button,
              transform: isButtonHovered ? "translateY(-2px)" : "translateY(0)",
              boxShadow: isButtonHovered 
                ? "0 6px 16px rgba(37, 211, 102, 0.3)" 
                : "0 4px 12px rgba(37, 211, 102, 0.25)"
            }}
            onMouseEnter={() => setIsButtonHovered(true)}
            onMouseLeave={() => setIsButtonHovered(false)}
            onClick={openWhatsApp}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="24px"
              height="24px"
              style={styles.icon}
            >
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.116.553 4.092 1.513 5.818L0 24l6.414-1.482C8.071 23.45 10.007 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.852 0-3.626-.5-5.145-1.452l-.372-.222-3.795.877.831-3.72-.242-.381C2.493 15.92 2 14.011 2 12 2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zm5.094-6.762c-.278-.139-1.644-.813-1.9-.906-.257-.093-.444-.139-.632.139-.186.277-.73.906-.897 1.093-.168.186-.334.209-.613.07-.278-.14-1.171-.431-2.23-1.373-.823-.733-1.378-1.638-1.539-1.917-.162-.278-.017-.429.122-.57.126-.126.278-.327.417-.49.14-.163.186-.279.28-.465.093-.186.046-.347-.023-.49-.07-.14-.613-1.473-.84-2.015-.221-.533-.445-.461-.63-.47l-.54-.01c-.186 0-.488.07-.74.35s-.972.95-.972 2.318 1.03 2.69 1.174 2.879c.139.186 2.032 3.107 4.93 4.352.688.297 1.225.475 1.642.61.69.22 1.316.189 1.813.114.553-.082 1.644-.67 1.877-1.319.232-.65.232-1.207.162-1.33-.07-.122-.255-.186-.532-.325z" />
            </svg>
            Start Chat
          </button>
          <p style={styles.footerText}>
            Typically replies within 15 minutes
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    background: "linear-gradient(135deg, #f8fdff 0%, #f0f9fb 100%)",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
    padding: "20px",
  },
  card: {
    backgroundColor: "white",
    padding: "50px 40px",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
    maxWidth: "520px",
    textAlign: "center",
    width: "100%",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  iconContainer: {
    marginBottom: "20px",
  },
  textContainer: {
    marginBottom: "32px",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#00796b",
    marginBottom: "16px",
    letterSpacing: "-0.5px",
  },
  infoText: {
    fontSize: "16px",
    color: "#555",
    lineHeight: "1.6",
    margin: "0",
  },
  button: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#25D366",
    color: "white",
    padding: "16px 32px",
    borderRadius: "30px",
    border: "none",
    fontSize: "17px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginBottom: "16px",
    minWidth: "220px",
  },
  icon: {
    marginRight: "10px",
  },
  footerText: {
    fontSize: "14px",
    color: "#888",
    margin: "0",
    fontStyle: "italic",
  },
};

export default ChatWithPharmacist;